import axios from 'axios'
import API from '@/services/API/api'
import SlSaleCreditNote from '@/models/Sale/SlSaleCreditNote'
import store from '../../../store/store'

const userCode = store.state.AuthModule.user
    ? store.state.AuthModule.user.auth_code
    : ''
const supervisorCode = store.state.UniqueKeyModule.uniqueKey

const getDTE = async function(number, type) {
    let ticket = type == 2 ? 0 : 1

    try {
        let response = await axios.get(
            //'http://dgz1.cl/public/api/pos_daily_cash',
            API.SEARCH_TICKET + number,
            {
                params: {
                    is_ticket: ticket,
                },
            }
        )
        return response
    } catch (error) {
        console.log('ERROR')
        console.log(error.response)
        return error.response.data
    }
}

const generateCreditNote = async function(
    dteNumber,
    isTicket,
    comment,
    creditNoteNumber = null,
    superCode = null,
    flagCashReturn = false,
    flagWithTransbankCreditCancellation = false,
) {
    try {
        console.log('SUPERVISOR', supervisorCode)
        let response = await axios.post(API.GENERATE_SALE, {
            comment: comment,
            dte_number: dteNumber,
            is_ticket: isTicket,
            //seller_user_code: userCode,
            supervisor_user_code: superCode || supervisorCode,
            credit_note_counter: creditNoteNumber,
            flag_cash_return: flagCashReturn,
            flag_with_transbank_credit_cancelation: flagWithTransbankCreditCancellation,
        })
        return response.data
    } catch (error) {
        return error.response
    }
}

//
const getCreditNoteByFolio = async function(number) {
    try {
        let response = await SlSaleCreditNote.where('number', number).get()
        return response.data.filter(item => item.number == number)
    } catch (error) {
        return error.response.data
    }
}

export default { getDTE, generateCreditNote, getCreditNoteByFolio }
